export { default } from './ServicesAuthorizationTerm';